/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.create.schedules.create.pricing.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.templates',
  'acme.common.service.discounts',
  'acme.common.service.themesHelper',
  'acme.application.templates.create.pricing.accounts.controllers',
  'acme.application.templates.create.pricing.coupons.controllers',
  'acme.application.templates.create.pricing.members.controllers'
])

.controller('TemplatesCreateSchedulesCreatePricingController', ['$scope', '$state', '$timeout', 'HelpersService', 'TemplatesService', 'ApiService',  'DiscountsService', 'ThemesHelperService', function($scope, $state, $timeout, HelpersService, TemplatesService, ApiService, DiscountsService, ThemesHelperService) {

    $scope.templatesCreateSchedulesCreatePricing = {

      model: {
        priceLists: [],
        salesChannels: []
      },

      template: {},
      priceLists: [],
      currentPriceList: {},
      hasValidPriceList: false,
      tab: 'general',

      init: function() {

        this.template = TemplatesService.getModel();
        $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
        $scope.$on('TemplatesCreateSchedulesCreateController::Save', this.onTemplatesCreateSchedulesCreateControllerSave);

        if ($state.params && $state.params.scheduleId) {
          this.model = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
        }else{
          this.model = TemplatesService.getNewSchedule().schedule;
        }

        this.currentPriceList = TemplatesService.processSalesChannels(TemplatesService.getSchedulePriceList(this.model));

        this.getPriceLists();
        this.getDiscountCodes();

        console.log('TemplatesCreateSchedulesCreatePricingController::init');

      },

      getPriceLists: function() {
        ApiService.price.lists.list(HelpersService.getPaginator()).then(this.success.getPriceLists, this.error.getPriceLists);
      },

      getPriceList: function(id) {
        ApiService.price.lists.detail(id).then(this.success.getPriceList, this.error.getPriceList);
      },

      getDiscountCodes: function() {
        ApiService.discounts.list('v2', HelpersService.getPaginator()).then(this.success.getDiscountCodes, this.error.getDiscountCodes);
      },

      isTab: function(tab) {
        return (this.tab === tab);
      },

      setTab: function(tab) {
        this.tab = tab;
        $scope.$broadcast('TemplatesCreatePricing::Update', { view: this.tab });
      },

      // Price lists
      hasPriceLists: function() {
        return (this.priceLists.length > 0);
      },

      hasPrices: function() {
        this.hasValidPriceList = (this.currentPriceList && this.currentPriceList.hasOwnProperty('prices') && this.currentPriceList.prices instanceof Array);
        return this.hasValidPriceList;
      },

      findPriceList: function(id) {
        var i, ii,
          r = false;

        if (id) {
          for (i=0,ii=this.priceLists.length;i<ii;i++) {
            if (this.priceLists[i].id === id) {
              r = {
                index: i,
                list: TemplatesService.processSalesChannels(this.priceLists[i])
              };
              break;
            }
          }
        }

        return r;
      },

      // Discount codes
      findDiscountCode: function(id) {
        return DiscountsService.find(id);
      },

      isEnableSalesRules: function() {
        return ThemesHelperService.getCompany('enableSalesView');
      },

      success: {
        init: function(response) {},

        getPriceList: function(response) {
          var self = $scope.templatesCreateSchedulesCreatePricing;
          self.currentPriceList = response.data.payload;
        },

        getPriceLists: function(response) {

          var i, ii,
              priceList,
              self = $scope.templatesCreateSchedulesCreatePricing;

          self.priceLists = response.data.payload.list;

          for (i=0,ii=self.priceLists.length;i<ii;i++) {
            self.priceLists[i] = TemplatesService.processSalesChannels(self.priceLists[i]);
          }

          if (self.currentPriceList && self.currentPriceList.hasOwnProperty('id')) {
            priceList = self.findPriceList(self.currentPriceList.id);
            if (priceList) {
              self.priceLists[priceList.index] = self.currentPriceList;
            }
          }

        },

        getDiscountCodes: function(response) {
          DiscountsService.setModel(response.data.payload.list);
        }
      },

      error: {
        init: function(response) {},
        getPriceList: function(response) {
          $scope.templatesCreateSchedulesCreatePricing.error.generic(response);
        },
        getPriceLists: function(response) {
          $scope.templatesCreateSchedulesCreatePricing.error.generic(response);
        },
        getDiscountCodes: function(response) {
          $scope.templatesCreateSchedulesCreatePricing.error.generic(response);
        },
        generic: function(response) {
          $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: response.data.error });
        }
      },

      onTemplatesCreateSchedulesCreateControllerSave: function(e, data) {
        var self = $scope.templatesCreateSchedulesCreatePricing,
            currentPriceList = angular.toJson(self.currentPriceList),
            templatePriceList = angular.toJson(TemplatesService.getPriceList());

        // Rudimentary check for price list equality to determine whether or not to save
        if (currentPriceList !== templatePriceList) {
          console.log('TemplatesCreateSchedulesCreatePricingController::onTemplatesCreateSchedulesCreateControllerSave');
          TemplatesService.setSchedulePriceList(self.model, self.currentPriceList);
          TemplatesService.setSchedule(self.model);
        }else{
          TemplatesService.clearSchedulePriceList(self.model);
        }
      },

      onTemplatesServiceUpdate: function(e, data) {
        var priceList,
          self = $scope.templatesCreateSchedulesCreatePricing;

        self.template = TemplatesService.getModel();

        // Next Tick
        $timeout(function() {
          // Find in priceLists
          priceList = self.findPriceList(TemplatesService.getSchedulePriceList(this.model).id);
          // Override matching price list with what is in the template
          self.priceLists[priceList.index] = TemplatesService.getSchedulePriceList(this.model);
          // Assign to currentPriceList
          self.currentPriceList = TemplatesService.processSalesChannels(self.priceLists[priceList.index]);
        }, 0);
      }

    };


    $scope.pricingGridOptions = {
      enableRowSelection: false,
      paginate: false,
      multiSelect: false,
      columnDefs: [
        {
          field: 'personType.displayOrder',
          displayName: 'Order',
          visible: false
        },
        {
          field: 'personType.name',
          displayName: 'Ticket Type'
        },
        {
          field: 'personType.description',
          displayName: 'Description'
        },
        {
          field: 'price',
          displayName: 'Price',
          cellFilter: 'currency',
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
          enableCellEdit: true,
          enableCellEditOnFocus: true
        },
        {
          field: 'salesChannels[0].enabled',
          displayName: 'Web',
          cellTemplate: '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket type {{ row.entity.personType.name }} Web</span></label></div>'
        },
        {
          field: 'salesChannels[1].enabled',
          displayName: 'POS',
          cellTemplate: '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket type {{ row.entity.personType.name }} POS</span></label></div>'
        },
        {
          field: 'salesChannels[2].enabled',
          displayName: 'Reseller',
          cellTemplate: '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" data-ng-disabled="templatesCreateSchedulesCreatePricing.template.memberOnlyEvent" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket type {{ row.entity.personType.name }} Reseller</span></label></div>',
          visible: true
        },
        {
          field: 'salesChannels[3].enabled',
          displayName: 'Customer Rep.',
          cellTemplate: '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket type {{ row.entity.personType.name }} Customer Rep.</span></label></div>',
          visible: true
        },
        {
          field: 'salesChannels[5].enabled',
          displayName: 'Kiosk',
          cellTemplate: '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket type {{ row.entity.personType.name }} Kiosk</span></label></div>',
          visible: true
        }
      ]
    };


    $scope.templatesCreateSchedulesCreatePricing.init();

}]);